import {replaceSpecialCodes} from "../utils/utils";
import FilltextSubcomponent from "../exercisesubcomponents/FilltextSubcomponent";
import React, {useState} from "react";
import ActionsComponent from "../components/ActionsComponent";
import globalVars from "../utils/globalVars";

export default function FillquestionComponent(props) {
    const [showSolution, setShowSolution] = useState(false);

    function handleShowSolution() {
        setShowSolution(!showSolution)
    }

    const [showFeedback, setShowFeedback] = useState(false);

    function handleShowFeedback() {
        setShowFeedback(!showFeedback)
    }

    return (
        <div key={props.index}>
            <FilltextSubcomponent
                showSolution={showSolution}
                showFeedback={showFeedback}
                filltext={replaceSpecialCodes(props.exercise.filltext)}/>
            <ActionsComponent
                onToggleShowSolution={handleShowSolution}
                onToggleShowFeedback={handleShowFeedback}
                {...props}
            />
            {showSolution &&
            <p><span style={{backgroundColor: globalVars.solutionMode.on, color: '#333'}}>Gehen Sie mit dem Mauszeiger über das Feld, um die richtige Antwort anzuzeigen</span>
            </p>}
        </div>
    );
}
